/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Verdict assigned to the case
 * @export
 */
export const ControlVerdict3 = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict3 = typeof ControlVerdict3[keyof typeof ControlVerdict3];


export function ControlVerdict3FromJSON(json: any): ControlVerdict3 {
    return ControlVerdict3FromJSONTyped(json, false);
}

export function ControlVerdict3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict3 {
    return json as ControlVerdict3;
}

export function ControlVerdict3ToJSON(value?: ControlVerdict3 | null): any {
    return value as any;
}

